<template>
  <div>
    <div v-if="!projectLoaded || !imagesLoadComplete" class="project-loading">
      <div class="loader">Loading...</div>
      <div v-if="projectLoaded" class="progress">
        <div class="progress-bar" role="progressbar" :style="progressPercentage" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
      </div>
    </div>
    <BreadCrumbHeader 
      :title="projectData.title"
      :breadCrumbs="breadCrumbs"
      :lastCrumb="$route.params.project_code" />
    <div class="basic-blog-area pt-90 pb-20">
      <div class="container">
        <ProjectDetailCover 
          :about="projectData.aboutItems"
          :summary="projectData.summary"
          :goals="projectData.goals"
          :image="projectData.cover"
           @image-loaded="handleImageLoadCount"/>
          <div v-if="projectData.quote" class="post-content">
            <blockquote class="single-blockquote">
              <p>{{projectData.quote}}</p>
            </blockquote>
          </div>
          <ProjectDetailProcess v-for="(detailProcess,index) in projectData.process" v-bind:key="index" :detailProcess="detailProcess"  @image-loaded="handleImageLoadCount"/>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

import BreadCrumbHeader from '@/components/elements/BreadCrumbHeader.vue';
import ProjectDetailCover from '@/components/pages/ProjectDetail/ProjectDetailCover.vue';
import ProjectDetailProcess from '@/components/pages/ProjectDetail/ProjectDetailProcess.vue';

export default {
  components: {
    BreadCrumbHeader,
    ProjectDetailCover,
    ProjectDetailProcess
  },
  computed: {
    progressPercentage() {
       const percentage = (this.imagesLoadCount / this.totalImages) * 100;
       return `width: ${percentage.toFixed(2)}%;`
    }
  },
  data() {
    return {
      breadCrumbs: {
        Home: '/',
        Portfolio: '/portfolio'
      },
      projectData: {},
      projectLoaded: false,
      imagesLoadComplete: false,
      totalImages: 0,
      imagesLoadCount: 0
    };
  },
  created() {
    axios.get(`/static-api/projects/${this.$route.params.project_code}.json`).then(response => {
      this.projectData = response.data;
      this.projectLoaded = true;
      this.totalImages = 1; // Cover also counts
      for(var process of this.projectData.process) {
        for(var processImage of process.images) {
          if(processImage.src) 
            this.totalImages++;
        }
      }
    }).catch(e => {
      // eslint-disable-next-line
      console.error(e);
    });
  },
  methods: {
    handleImageLoadCount() {
      this.imagesLoadCount++;
      if(this.totalImages == this.imagesLoadCount) {
        this.imagesLoadComplete = true;
      }
    }
  }
};
</script>
<style scoped>
.single-blockquote {
  margin-top: 15px;
}
.project-loading {
  position: fixed;
  height: 100%;
  width: 100%;
  display: block;
  background-color: rgba(255,255,255,0.8);
  z-index: 999;
}
</style>